import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
// style
import './assets/css/element.scss';
// import Video from "video.js"
// import "video.js/dist/video-js.css"

Vue.config.productionTip = false;

// 全局css样式
import "./assets/css/common.scss";
import "animate.css";
import './assets/css/computer.scss';
import './assets/css/mobile.scss';

// 自适应js文件===>淘宝无线适配
import "./assets/js/flexible.js";
// Vue.prototype.$Video = Video;
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
